import Landing from "components/landing/Landing"

export default Landing